import React from 'react';
import { useAccess } from '../lib/access';

// The "Views" section of every sidebar. Shows only what the person's role can use (from my_access()).
const ITEMS = [
  { view: 'my-work', className: 'mobile-home', icon: '🧰', iconLabel: 'My work', mobile: 'My work', desktop: 'My Work' },
  { view: 'tasks', className: 'mobile-home', icon: '🏠', iconLabel: 'Home', mobile: 'Home', desktop: 'Tasks', mobileClass: 'mobile-home' },
  { view: 'vendors', desktop: 'Vendors' },
  { view: 'calendar', desktop: 'Calendar' },
  { view: 'templates', className: 'mobile-templates', icon: '✉️', iconLabel: 'Templates', mobile: 'Messages', desktop: 'Templates', mobileClass: 'mobile-templates' },
  { view: 'jobs', className: 'mobile-jobs', icon: '🔨', iconLabel: 'Jobs', mobile: 'Jobs', desktop: 'Jobs', mobileClass: 'mobile-jobs' },
  { view: 'revenue', className: 'mobile-revenue', icon: '💰', iconLabel: 'Revenue', mobile: 'Revenue', desktop: 'Revenue', mobileClass: 'mobile-revenue' },
  { view: 'admin', className: 'mobile-revenue', icon: '⚙️', iconLabel: 'Admin', mobile: 'Admin', desktop: 'Admin', mobileClass: 'mobile-revenue' },
];

export default function ViewsNav({ currentView, onNavigate }) {
  const { views } = useAccess();
  return (
    <div className="sidebar-section">
      <div className="sidebar-section-label">Views</div>
      {ITEMS.filter(item => views.has(item.view)).map(item => (
        <div
          key={item.view}
          className={`sidebar-item ${item.className || ''} ${currentView === item.view ? 'active' : ''}`}
          onClick={() => onNavigate(item.view)}
          data-nav={item.view}
        >
          {item.icon ? (
            <>
              <span className={`${item.mobileClass || 'mobile-home'}-icon`} role="img" aria-label={item.iconLabel}>{item.icon}</span>
              <span className={`${item.mobileClass || 'mobile-home'}-label`}>{item.mobile}</span>
              <span className="desktop-label">{item.desktop}</span>
            </>
          ) : item.desktop}
        </div>
      ))}
    </div>
  );
}
